import styled from 'styled-components'

export const StyledPaymentContainer = styled.div`
  margin: auto;
  align-items: center;
  margin-bottom: 60px;

  .payment-head {
    max-width: ${props => props.theme.maxWidth};
    margin: auto;
    padding: 3rem 4vw 1rem 4vw;

    h3 {
      margin: 5px 0;
      font-size: calc(10pt + 1vw);
      text-align: center;
      font-weight: 500;
    }
    p {
      margin: 30px 0;
      text-align: center;
    }
    hr {
      border-top: 2px solid ${props => props.theme.highlightColor};
      border-bottom: none;
      width: 100%;
    }
    .heading {
      font-size: 13pt;
    }
  }

  .payment-body {
    max-width: ${props => props.theme.maxWidth};
    margin: auto;
    padding: 0 4vw 3rem 4vw;
    .panel {
      max-width: 400px;
    }
    p {
      font-size: 11pt;
      line-height: 17pt;
      margin-bottom: 40px;
    }
    .item-list {
      margin-top: 10px;
    }
    .amount {
      margin-left: 10px;
      font-weight: 600;
      font-size: 25px;
    }
    .error {
      font-size: 12pt;
      color: red;
    }
  }

  .payment-footer {
    text-align: center;
    padding: 5px 30px;
    line-height: 25px;
  }

  @media only screen and (max-width: 600px) {
    .payment-body {
      padding: 0 1vw 3rem 1vw;
      .panel {
        max-width: 100%;
        margin: auto;
      }
    }
  }
`

export const PaygateRedirectForm = styled.div`
  top: 50%;
  left: 50%;
  width: 30em;
  height: 18em;
  margin-top: -9em;
  margin-left: -15em;
  position: fixed;
  text-align: center;
  img {
    width: 100pt;
    height: 100pt;
    margin: 60pt;
  }
`

// export const PaymentGrid = styled.div`
//  display: grid;
//  grid-template-columns: repeat(auto-fit,minmax(300px,1fr));
//  grid-gap: 20px;
// `;

// Use one column and leave right space empty for now, may change if needed after testing.
export const PaymentGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(1, minmax(400px, 1fr));
  grid-gap: 20px;
`
